import {ReactNode} from 'react';

import {
  InlineDataComponentRegistry,
  InlineDataEventBus,
  InlineDataService,
  InlineDataProvider as Provider,
} from '@stripe-internal/inline-data';

import {useApp} from '../hooks/appHooks';

type Props = {
  components?: InlineDataComponentRegistry;
  children: ReactNode;
};

type InlineDataProviderBaseProps = Props & {
  bus: InlineDataEventBus;
  service: InlineDataService;
};

export function InlineDataProviderBase({
  bus,
  service,
  components = {},
  children,
}: InlineDataProviderBaseProps) {
  return (
    <Provider bus={bus} value={{service, components}}>
      {children}
    </Provider>
  );
}

// Should be provided within the conversations-assistant app context
export function InlineDataProvider({components = {}, children}: Props) {
  const app = useApp();
  return (
    <InlineDataProviderBase
      bus={app.inlineDataEventBus}
      service={app.inlineDataService}
      components={components}
    >
      {children}
    </InlineDataProviderBase>
  );
}
